export default {
  emailIsValid: email => {
    return /[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}/i.test(email);
  },
};
